/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyRestApiUrlGeneratorService" />
import { VssService, IVssService, Services } from "VSS/Platform/Context";
import { replaceRouteValues } from "VSS/Platform/Util/Url";
import { IRestApiRoutes, generatePackagingServiceRestApiUri } from "Feed/Legacy/Utils/RestApi";

const IvyArea: string = "ivy";

// Used in Ctf
const ServiceIndex: IRestApiRoutes = {
    locationId: "7950DD8B-C21E-4AB7-9E76-F43611EEBA95",
    resource: "v1",
    routeTemplate: "_packaging/{feed}/{area}/{resource}/{*path}"
};

export interface IIvyRestApiUrlGeneratorService extends IVssService {
    getEndpointUrl(feedId: string): string;
}

class IvyRestApiUrlGeneratorService extends VssService implements IIvyRestApiUrlGeneratorService {
    public getEndpointUrl(feedId: string): string {
        const path = replaceRouteValues(ServiceIndex.routeTemplate, {
            feed: feedId,
            area: IvyArea,
            resource: ServiceIndex.resource
        });

        return generatePackagingServiceRestApiUri(this.pageContext, path, true /* ignoreApisRelativePath */);
    }
}

Services.add("IIvyRestApiUrlGeneratorService", { serviceFactory: IvyRestApiUrlGeneratorService });
